module.exports = __webpack_public_path__ + "img/9_2b774fac0.png";